import React from 'react'
import get from 'lodash.get'
import {getVimeoCodeFromUrl} from 'lib/util'
import {isInWebApp} from 'lib/webapp'
import CollageProduct from './assets/collage-product.jpg'
import DigitalRetouchedFurnishingPhotoProduct from './assets/furnishing-photo-product.jpg'
import DigitalRetouchedRenovationPhotoProduct from './assets/renovation-photo-product.jpg'
import DigitalRetouchedPeoplePhotoProduct from './assets/people-photo-product.jpg'
import DigitalStylingProduct from './assets/digital-styling-product.png'
import Drone360Product from './assets/drone360-product.jpg'
import DronePhotoProduct from './assets/drone-photo-product.jpg'
import ElevatedPhotoProduct from './assets/elevated-photo-product.jpg'
import EnergyLabelingProduct from './assets/energy-labeling-product.jpg'
import EveningPhotoProduct from './assets/evening-photo-product.jpg'
import ExclusivePhotoProduct from './assets/exclusive-photo-product.jpg'
import FacadePhotoProduct from './assets/facade-photo-product.jpg'
import FlexiblePremiumPhotoProduct from './assets/flexible-premium-photo-product.jpg'
import FloorPlansProduct from './assets/floor-plans-product.jpg'
import LocalAreaPhotoProduct from './assets/local-area-photo-product.jpg'
import MastPremiumPhotoProduct from './assets/mast-premium-photo-product.jpg'
import Object360Product from './assets/object360-product.jpg'
import ParallaxVideoProduct from './assets/parallax-video-product.jpg'
import PlanDrawingProduct from './assets/plan-drawing-product.jpg'
import PortraitPhotoProduct from './assets/portrait-photo-product.jpg'
import PremiumHighPhotoProduct from './assets/premium-high-photo-product.jpg'
import PrePhotoProduct from './assets/pre-photo-product.jpg'
import RetouchedEveningPhotoProduct from './assets/retouched-evening-photo-product.jpg'
import SlideshowProduct from './assets/slideshow-product.jpg'
import SlidesProduct from './assets/slides-product.jpg'
import Some10Product from './assets/some10-product.jpg'
import StandardPhotoProduct from './assets/standard-photo-product.jpg'
import StylingProduct from './assets/styling-product.jpg'
import VideoProduct from './assets/video-product.jpg'
import VirtualTourProduct from './assets/virtual-tour-product.jpg'
import VisoProduct from './assets/viso-product.jpg'
import WalkthroughProduct from './assets/walkthrough-product.jpg'

const previews = {
  CollageProduct,
  DigitalPlanDrawingProduct: PlanDrawingProduct,
  DigitalRetouchedFurnishingPhotoProduct,
  DigitalRetouchedRenovationPhotoProduct,
  DigitalRetouchedPeoplePhotoProduct,
  DigitalStylingProduct,
  Drone360Product,
  DronePhotoProduct,
  DronePremiumPhotoProduct: DronePhotoProduct,
  ElevatedPhotoProduct,
  EnergyLabelingProduct,
  EveningPhotoProduct,
  ExclusivePhotoProduct,
  FacadePhotoProduct,
  FlexiblePremiumPhotoProduct,
  FloorPlansProduct,
  LocalAreaPhotoProduct,
  MastPremiumPhotoProduct,
  Object360Product,
  ParallaxVideoProduct,
  PanoramaPhotoProduct: DronePhotoProduct,
  PlanDrawingProduct,
  PortraitPhotoProduct,
  PremiumHighPhotoProduct,
  PrePhotoProduct,
  RetouchedEveningPhotoProduct,
  SlideshowProduct,
  SlidesProduct,
  Some10Product,
  StandardPhotoProduct,
  StylingProduct,
  VideoProduct,
  VirtualTourProduct,
  VisoProduct,
  WalkthroughProduct,
}

const videoCandidates = {
  VideoProduct: {
    types: 'videoTypes',
    variant: 'videoVariant'
  },
  SlideshowProduct: {
    types: 'slideshowTypes',
    variant: 'slideshowVariant'
  },
}

const ProductPreview = ({product, productAvailability}) => {
  const preview = previews[product.__typename]

  const getVideoUrl = () => {
    const videoCandidate = videoCandidates[product.__typename]
    if (!productAvailability) return null
    if (!videoCandidate) return null

    const types = productAvailability[videoCandidate.types]
    const variant = types.find(({type}) => type === product[videoCandidate.variant])

    if (!variant) return null

    const path = product.drone ? 'extraProductOptions.drone' : 'exampleUrl'
    return get(variant, path, null)
  }

  const goToVideoUrl = (e) => {
    if (isInWebApp()) {
      e.preventDefault()
    }
  }

  const videoUrl = getVideoUrl()

  if (videoUrl) {
    const vimeoCode = getVimeoCodeFromUrl(videoUrl)
    return (
      <div className="product-preview">
        <iframe
          title="Video"
          src={`https://player.vimeo.com/video/${vimeoCode}`}
          frameBorder="0"
        />
        <a
          href={videoUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={goToVideoUrl}
        >
          Åpne video i nytt vindu
        </a>
      </div>
    )
  }

  if (preview) {
    return (
      <div
        className="product-preview"
        style={{backgroundImage: `url(${preview})`}}
      />
    )
  }

  return null
}

export default ProductPreview
